import { render, staticRenderFns } from "./RolePermissions.vue?vue&type=template&id=24d3bc8f&scoped=true"
import script from "./RolePermissions.vue?vue&type=script&lang=js"
export * from "./RolePermissions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24d3bc8f",
  null
  
)

export default component.exports